export default __webpack_public_path__ + "static/media/ServiceNow.a09f5f37.png";